import Vue from 'vue';

const utils = {
    uuid: function () {
        var s = [];
        var hexDigits = '0123456789abcdef';
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = '-';

        var uuid = s.join('');
        return uuid;
    },

    typeJudge: function (data, type) {
        return Object.prototype.toString.call(data) === `[object ${type}]`;
    },
    offerSource: function (params) {
        const { offerSource, sourceProductId } = params;
        const data = {
            val: '',
            sourceProduct: '',
        };
        switch (offerSource) {
            case 0:
                data.val = '阿里巴巴';
                data.sourceProduct = 'http://detail.1688.com/offer/' + sourceProductId + '.html';
                break;
            case 1:
                data.val = '淘宝';
                data.sourceProduct = 'https://item.taobao.com/item.htm?id=' + sourceProductId;

                break;
            case 2:
                data.val = '天猫';
                data.sourceProduct = 'https://detail.tmall.com/item.htm?id=' + sourceProductId;
                break;
            case 3:
                data.val = '极有家';
                data.sourceProduct = ' https://item.taobao.com/item.htm?id=' + sourceProductId;
                break;
            case 4:
                data.val = '天猫国际';
                data.sourceProduct = 'https://detail.tmall.hk/hk/item.htm?id=' + sourceProductId;
                break;
            case 5:
                data.val = '阿里大市场';
                data.sourceProduct = 'http://detail.1688.com/offer/' + sourceProductId + '.html';
                break;
            case 6:
                data.val = '拼多多';
                data.sourceProduct = 'http://yangkeduo.com/goods.html?goods_id=' + sourceProductId;
                break;
            case 7:
                data.val = '快手';
                data.sourceProduct = 'https://s.kwaixiaodian.com/goods/detail?id=' + sourceProductId;
                break;
            case 8:
                data.val = '抖音';
                data.sourceProduct = 'https://haohuo.jinritemai.com/views/product/item2?id=' + sourceProductId;
                break;
            default:
                data.val = '暂无';
                data.sourceProduct = '';
                break;
        }
        return data;
    },
    formatTime: function (date, format) {
        if (typeof date === 'string') {
            var mts = date.match(/(\/Date\((\d+)\)\/)/);
            if (mts && mts.length >= 3) {
                date = parseInt(mts[2]);
            }
        }
        date = new Date(date);
        if (!date || date.toUTCString() == 'Invalid Date') {
            return '';
        }
        var map = {
            M: date.getMonth() + 1, // 月份
            d: date.getDate(), // 日
            h: date.getHours(), // 小时
            m: date.getMinutes(), // 分
            s: date.getSeconds(), // 秒
            q: Math.floor((date.getMonth() + 3) / 3), // 季度
            S: date.getMilliseconds(), // 毫秒
        };
        format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
            var v = map[t];
            if (v !== undefined) {
                if (all.length > 1) {
                    v = '0' + v;
                    v = v.substr(v.length - 2);
                }
                return v;
            } else if (t === 'y') {
                return (date.getFullYear() + '').substr(4 - all.length);
            }
            return all;
        });
        return format;
    },
    /**
     * @name:
     * @Description: 说明
     * @param {String} name local名
     * @param {String} field 单字段换值的时候 字段名
     * @param {*} value 值
     * @return {type}
     * @Author:
     */

    localConfigSet(name, field, value) {
        if (!name || typeof name !== 'string') {
            console.error('name为空或者不为string类型');
            return;
        }
        // if (!field && typeof value !== "string") {
        //   localStorage.setItem(name, value);
        //   return;
        // } else {
        //   localStorage.setItem(name, JSON.stringify(value));
        //   return;
        // }
        if (!field) {
            if (typeof value === 'object') {
                localStorage.setItem(name, JSON.stringify(value));
            } else {
                localStorage.setItem(name, value);
            }
        } else {
            let strData = {};
            if (localStorage.getItem(name)) {
                try {
                    strData = JSON.parse(localStorage.getItem(name));
                } catch (error) {
                    //
                }
            }
            if (typeof value === 'object') {
                strData[field] = JSON.stringify(value);
                localStorage.setItem(name, JSON.stringify(strData));
            } else {
                strData[field] = value;
                localStorage.setItem(name, JSON.stringify(strData));
            }
        }
    },
    /**
     * @name:
     * @Description: 说明
     * @param {string} name 需要取的local值
     * @param {string} field 需要取的local值中字段名
     * @return {*} 返回取的值
     * @Author:
     */

    localConfigGet(name, field) {
        try {
            const data = JSON.parse(localStorage.getItem(name));
            if (!field) {
                return data;
            } else {
                return data[field];
            }
        } catch (e) {
            return localStorage.getItem(name);
        }
    },
    /**
     * @name: strBytes
     * @Description: 判断字节数
     * @param {String} 输入的字符串
     * @return {Number} 字节换算出来的数量
     * @Author:
     */

    strBytes(v) {
        // eslint-disable-next-line no-control-regex
        const personNameBytes = v.replace(/[^\x00-\xff]/g, '01').length / 2;
        return Number.isInteger(personNameBytes) ? personNameBytes : Math.ceil(personNameBytes);
    },

    // 获取连接上的key
    getUrlKey: function (name) {
        return (
            decodeURIComponent(
                // eslint-disable-next-line no-useless-concat
                (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [null, ''])[1].replace(
                    /\+/g,
                    '%20'
                )
            ) || null
        );
    },
};

Vue.prototype.$utils = utils;
